import { createContext } from "react";

// Product routing interface
export interface MerchantRoutes {
  // Home routes
  overviewHref: string;
  spotlightsHref: string;
  getSpotlightsSubRoute: (subPath: string) => string;
  homeBaseHref: string;
  analyticsHref: string;
  getAnalyticsSubRoute: (subPath: string) => string;

  // Order management routes
  orderManagementDefaultRoute: string;
  ordersOutboundLabelsHref: string;
  getOrdersOutboundLabelsSubRoute: (subPath: string) => string;
  returnsHref: string;
  getReturnsSubRoute: (subPath: string) => string;
  claimsHref: string;
  claimsDefaultRoute: string;
  pickSessionHref: string;
  pickSessionTableHref: string;
  transferHref: string;
  instantTransferHref: string;
  consolidationHref: string;

  getClaimsSubRoute: (subPath: string) => string;

  getWarrantiesHref: ({ enabled }: { enabled: boolean }) => string;
  warrantiesHref: string;
  getWarrantiesSubRoute: (subPath: string) => string;

  getRecycleHref: () => string;
  recycleHref: string;
  getRecycleSubRoute: (subPath: string) => string;

  registrationsHref: string;
  warehouseHref: string;
  warehouseBaseUrl: string;
  returnsProcessingHref: string;
  tariffCalculatorHref: string;
  orderEditsHref: string;
  classifyProductsHref: string;
  analyticsOrderFulfillmentHref: string;
  getAnalyticsOrderFulfillmentSubRoute: (subPath: string) => string;
  analyticsReturnsClaimsHref: string;
  getAnalyticsReturnsClaimsSubRoute: (subPath: string) => string;
  analyticsReportsHref: string;
  analyticsReturnsProcessingHref: string;

  // Inventory routes
  getInventoryHref: ({ enabled }: { enabled: boolean }) => string;
  inventoryProductsHref: string;

  // Marketing routes
  marketingAnalyticsHref: string;
  automationsHref: string;
  getSegmentBuilderRoute({
    teamId,
    segmentId,
  }: {
    teamId: string;
    segmentId: string;
  }): string;
  getTrackingHref: ({ enabled }: { enabled: boolean }) => string;
  getTrackingSubRoute: (subPath: string) => string;
  recoverHref: string;
  getRecoverSubRoute: (subPath: string) => string;
  reviewsHref: string;
  getReviewsSubRoute: (subPath: string) => string;
  emailSmsHref: string;
  getEmailSmsSubRoute: (subPath: string) => string;
  loyaltyHref: string;
  getLoyaltySubRoute: (subPath: string) => string;
  marketingAgentHref: string;
  getMarketingAgentSubRoute: (subPath: string) => string;

  // Support routes
  getSupportHref: ({ enabled }: { enabled: boolean }) => string;
  getSupportTableHref: (viewName: string) => string;
  getSupportTableSubRoute: (subPath: string) => string;
  getConciergeHref: ({ enabled }: { enabled: boolean }) => string;
  getConciergeSubRoute: (subPath: string) => string;
  getSupportDevSubRoute: (subPath: string) => string;

  // Conversion routes
  conversionAnalyticsHref: string;
  getConversionHref: ({
    enabled,
    checkoutOutboundRatesEnabled,
  }: {
    enabled: boolean;
    checkoutOutboundRatesEnabled: boolean;
  }) => string;
  getConversionSubRoute: (subPath: string) => string;

  // Marketing routes
  getMarketingHref: ({
    emailSmsEnabled,
    marketingCloudEnabled,
  }: {
    emailSmsEnabled: boolean;
    marketingCloudEnabled: boolean;
  }) => string;

  // Customers routes
  getCustomerRecordHref: ({ customerId }: { customerId?: string }) => string;

  // Settings routes
  settingsHref: string;
  getSettingsSubRoute: (subPath: string) => string;

  // Customer portal builder route
  customerPortalBuilderHref: string;

  // Base URLs for sections
  orderManagementBaseUrl: string;
  inventoryManagementBaseUrl: string;
  marketingBaseUrl: string;
  supportBaseUrl: string;
  conversionBaseUrl: string;
  customersBaseUrl: string;
  storeBaseUrl: string;
  aeoBaseUrl: string;

  // Finance routes
  financeBaseUrl: string;
  disputesHref: string;
  disputesDashboardHref: string;
  disputesChargebacksHref: string;
  disputesSettingsHref: string;
  disputesIntegrationsHref: string;

  // AEO routes
  aeoDashboardHref: string;
  aeoConfigureHref: string;
  aeoPromptsHref: string;
  aeoCatalogHref: string;
  getAeoSubRoute: (subPath: string) => string;
  getAeoCatalogSubRoute: (subPath: string) => string;
}

export const MerchantRoutesContext = createContext<MerchantRoutes | undefined>(
  undefined,
);
